import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { getInstructorDetail } from '../services/operations/profileApi';
import Loading from './Loading';
import CourseSlider from '../components/core/categoryPage/CourseSlider';
import RatingCard from '../components/common/RatingCard';
import Footer from '../components/common/Footer';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import { Autoplay } from 'swiper/modules';
import ConfirmationModal from '../components/common/ConfirmationModal';

const InstructorPage = () => {
  const { instructorId } = useParams();
  const [instructor, setInstructor] = useState([]);
  const [confirmationModal, setConfirmationModal] = useState(null);
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      getInstructorDetail(
        instructorId,
        setInstructor,
        setConfirmationModal,
        setLoading
      )
    );
  }, [dispatch, instructorId]);
  if (loading) {
    return (
      <div className='h-screen w-screen'>
        <Loading />
      </div>
    );
  }

  return (
    <div className='text-richblack-5 mt-14 font-inter'>
      <div className='bg-richblack-800'>
        <div className='w-11/12 max-w-maxContent mx-auto flex lg:flex-row flex-col-reverse gap-y-4 items-center justify-between lg:py-16 py-12 lg:px-40 px-4'>
          <div className='flex flex-col gap-3'>
            <p className='text-2xl text-richblack-100'>{instructor?.accountType}</p>
            <p className='text-4xl font-bold'>
              {instructor?.firstName} {instructor?.lastName}
            </p>
            <p className='text-lg font-semibold text-yellow-50'>
              {instructor?.totalStudent} Total Student(s) {instructor?.reviews?.length} Review(s)
            </p>
            <p className='text-richblack-300'>{instructor?.additionalDetails?.about}</p>
          </div>
          <div className='w-40'>
            <img
              src={instructor?.image}
              alt='Instructor'
              loading='lazy'
              className='w-full h-full aspect-square object-cover rounded-full'
            />
          </div>
        </div>
      </div>
      {instructor?.courses?.length > 0 && (
        <div className='my-16 w-11/12 max-w-maxContent mx-auto'>
          <header className='text-[2rem] text-center font-semibold mb-8'>
            Courses of {instructor?.firstName} {instructor?.lastName} ({instructor?.courses?.length})
          </header>
          <div>
            <CourseSlider courses={instructor?.courses} />
          </div>
        </div>
      )}
      {instructor?.reviews?.length > 0 && (
        <div className='my-20  w-11/12 max-w-maxContent mx-auto'>
          <header className='text-[2rem] text-center font-semibold mb-8'>
            Reviews From Students
          </header>
          <div className='w-full mb-10'>
            <div>
              <Swiper
                slidesPerView={4}
                spaceBetween={20}
                freeMode={true}
                autoplay={{
                  delay: 3000,
                  disableOnInteraction: false,
                }}
                modules={[Autoplay]}
                breakpoints={{
                  1270: {
                    slidesPerView: 4,
                  },
                  1024: {
                    slidesPerView: 3,
                  },
                  600: {
                    slidesPerView: 2,
                  },
                  0: {
                    slidesPerView: 1,
                  },
                }}
              >
                {instructor?.reviews?.map(review => (
                  <SwiperSlide key={review?._id}>
                    <div>
                      <RatingCard rating={review} />
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
          {confirmationModal && <ConfirmationModal modalData={confirmationModal} />}
        </div>
      )}
      <Footer />
    </div>
  );
};

export default InstructorPage;